// Shared state for the multi-page demo walkthrough.
// Each step of the tour that crosses a page boundary sets the next
// page key in sessionStorage so the new page can pick up the tour.

const DISMISSED_KEY = 'demo_walkthrough_dismissed';
const STATE_KEY     = 'demo_wt';

export const isDismissed = () =>
  localStorage.getItem(DISMISSED_KEY) === 'true';

export const dismissForever = () =>
  localStorage.setItem(DISMISSED_KEY, 'true');

/** Store which page the tour should resume on, scoped to a recording. */
export const setStep = (page, recordingId) =>
  sessionStorage.setItem(STATE_KEY, JSON.stringify({ page, recordingId }));

export const clearStep = () =>
  sessionStorage.removeItem(STATE_KEY);

/** Returns { page, recordingId } or null. */
export const getStep = () => {
  try { return JSON.parse(sessionStorage.getItem(STATE_KEY)); }
  catch { return null; }
};

/** True when the tour should resume on `page` for `recordingId`. */
export const shouldResume = (page, recordingId) => {
  const s = getStep();
  return s?.page === page && String(s?.recordingId) === String(recordingId);
};

/** HTML string for a "don't show this again" inline link. */
export const DONT_SHOW_LINK =
  `<br><br><a href="#" ` +
  `onclick="(function(){` +
    `localStorage.setItem('demo_walkthrough_dismissed','true');` +
    `document.querySelector('.driver-popover-close-btn')?.click();` +
    `return false;` +
  `})()" ` +
  `style="font-size:0.8em;color:#94a3b8;text-decoration:underline;">` +
  `Don't show this again</a>`;
